import StyledTextField from '@shared/components/core/field/StyledTextField';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function VoiceControlField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    return (
        <StyledTextField
            disabled={disabled}
            fullWidth
            value={value}
            label={t('common:voice.title')}
            placeholder={t('common:voice.placeholder')}
            onChange={(e) => onChange(e.target.value)}
        />
    );
}

export default VoiceControlField;
